export default {"src":"/_next/static/media/es.2f29356e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};